import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyEditor = _resolveComponent("CompanyEditor")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('acp.company_edit'),
    gap: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CompanyEditor, {
        "economic-sectors": _ctx.economicSectors,
        policies: _ctx.policies,
        company: _ctx.company,
        "qualification-groups": _ctx.qualificationGroups,
        "image-size": _ctx.imageSize,
        "emit-actions": true,
        onSubmit: _ctx.submit
      }, null, 8, ["economic-sectors", "policies", "company", "qualification-groups", "image-size", "onSubmit"])
    ]),
    _: 1
  }, 8, ["title"]))
}